import { useMemo } from "react";
import { tabFromPathname } from "./tabRouting";

// location_name/location_radius are bare query params shared across every SourceDirectory tab, so a
// tab honors them only when it owned the page's original pathname (initialPathname, frozen by
// SourceDirectory before any client-side tab switch) — the live pathname always names the current
// tab, so it would never catch the leak. A standalone mount (no initialPathname, no sibling tab to
// leak from) falls back to the live pathname.
//
// Read once and memoized: the returned values only seed the initial pill state and GeoSearchByPlace's
// initial props, so re-reading window on every later render would be wasted work.
export default function useOwnedLocationParams(initialPathname, ownTab) {
  return useMemo(() => {
    const owns = tabFromPathname(initialPathname ?? window.location.pathname, ownTab) === ownTab;
    const params = new URL(window.location.href).searchParams;

    return {
      locationName: owns ? params.get("location_name") : null,
      locationRadius: owns ? params.get("location_radius") : null,
    };
  }, [initialPathname, ownTab]);
}
